import { Dispatch } from 'react';
import { IAction } from 'appRedux/reducers';

import { IUserPlaylistItem } from 'appRedux/models/playerModels';

export const AppKey = 'PLAYLIST-';
export const playlistActionTypes = {
  ADD_PLAYLIST_ITEM: `${AppKey}ADD_PLAYLIST_ITEM`,
  REMOVE_PLAYLIST_ITEM: `${AppKey}REMOVE_PLAYLIST_ITEM`,
  REMOVE_PLAYLIST_ITEMS: `${AppKey}REMOVE_PLAYLIST_ITEMS`,
  SET_PLAYLIST: `${AppKey}SET_PLAYLIST`,
  CLEAR_PLAYLIST: `${AppKey}CLEAR_PLAYLIST`,
};

export const PlaylistReduxCommandCreator = (dispatch: Dispatch<IAction>) => ({
  AddPlaylistItem(item: IUserPlaylistItem) {
    dispatch({
      type: playlistActionTypes.ADD_PLAYLIST_ITEM,
      state: item,
    });
  },
  RemovePlaylistItem(slotNumber: number) {
    dispatch({
      type: playlistActionTypes.REMOVE_PLAYLIST_ITEM,
      state: slotNumber,
    });
  },
  // Remove many in a single dispatch so the playlist updates (and any dependent
  // list refresh fires) exactly once for a bulk removal.
  RemovePlaylistItems(slotNumbers: number[]) {
    dispatch({
      type: playlistActionTypes.REMOVE_PLAYLIST_ITEMS,
      state: slotNumbers,
    });
  },
  SetPlaylist(playlist: IUserPlaylistItem[]) {
    dispatch({
      type: playlistActionTypes.SET_PLAYLIST,
      state: playlist,
    });
  },
  ClearPlaylist() {
    dispatch({
      type: playlistActionTypes.CLEAR_PLAYLIST,
    });
  },
});
